import { Component, OnInit, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AuthService } from './services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';

declare const $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'doctarz';
  tourism: any = { medicalRecords: [], countryCode: '91' };
  deferredPrompt: any;
  promptCount = 0;

  @HostListener('window:beforeinstallprompt', ['$event'])
  onbeforeinstallprompt(e: any) {
    e.preventDefault();
    this.deferredPrompt = e;
    this.promptCount++;
    if (this.promptCount === 1) {
      $('#myModal').modal('show');
    }
  }

  constructor(
    private router: Router,
    private auth: AuthService,
    private toaster: ToastrService,
    private swUpdate: SwUpdate,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) return;
      window.scrollTo(0, 0);
      $(document.body).removeClass('modal-open');
      $('.modal-backdrop').remove();
    });
    this.checkNewVersion();
    this.translateDefault();
  }

  translateDefault() {
    this.translate.setDefaultLang('en');
    this.translate.use('en');
  }

  addToHomeScreen() {
    this.deferredPrompt.prompt();
    this.deferredPrompt.userChoice.then((choiceResult: any) => {
      this.deferredPrompt = null;
    });
  }

  checkNewVersion() {
    if (this.swUpdate.isEnabled) {
      // Angular 15 uses versionUpdates instead of .available
      this.swUpdate.versionUpdates
        .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
        .subscribe(() => {
          if (confirm('New version available. Load New Version?')) {
            window.location.reload();
          }
        });
    }
  }

  openMedicalTourism() { this.auth.changeMessage(); }

  goToLink(url: string) { window.open(url, '_blank'); }

  numberOnly(event: any, id: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    return !(charCode > 31 && (charCode < 48 || charCode > 57));
  }
}
